import { render, staticRenderFns } from "./campaignTable.vue?vue&type=template&id=554494d4&scoped=true"
import script from "./campaignTable.vue?vue&type=script&lang=js"
export * from "./campaignTable.vue?vue&type=script&lang=js"
import style0 from "./campaignTable.vue?vue&type=style&index=0&id=554494d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554494d4",
  null
  
)

export default component.exports